import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';

import { useBranch, useUsers, useUpdateBranch } from '../../hooks';
import { removeObjectProperties } from '../../utils';
import { Card, FormActions, FormSkeleton, PageHeader } from '../../components';
import { ROUTE_URLS } from '../../routes';
import { useI18n } from '../../i18n';
import { BranchFields } from './CreateBranch';

export const EditBranch = () => {
  const { id } = useParams();
  const { t } = useI18n();
  const { isLoading, mutateAsync: editBranch } = useUpdateBranch();
  const { data: branch, isLoading: isBranchLoading } = useBranch(id);
  const { data: users, isLoading: isUsersLoading } = useUsers();

  const onFinish = values => {
    const readyValues = removeObjectProperties(values, ['productName']);
    editBranch({ id, ...readyValues });
  };
  const defaultValues = useMemo(
    () => ({
      user_ids: branch?.users.map(user => user.id),
      name: branch?.name,
    }),
    [branch],
  );

  const loading = isBranchLoading || isUsersLoading;

  return (
    <div className='wm-form-page wm-form-page--narrow'>
      <PageHeader
        backTo={ROUTE_URLS.BRANCHES}
        backLabel={t('nav.branches')}
        title={t('branches.editTitle')}
        subtitle={branch?.name ?? t('branches.editSubtitle')}
      />
      {loading ? (
        <Card>
          <FormSkeleton fields={2} />
        </Card>
      ) : (
        <Form name='fields' layout='vertical' onFinish={onFinish} initialValues={defaultValues} requiredMark={false}>
          <Card>
            <BranchFields users={users} />
          </Card>
          <FormActions cancelTo={ROUTE_URLS.BRANCHES} submitting={isLoading} />
        </Form>
      )}
    </div>
  );
};
